import { Link } from "react-router";
import Button from "@/components/ui/button";

interface FormNotFoundProps {
	workspaceId: string;
	title?: string;
	description?: string;
}

export function FormNotFound({
	workspaceId,
	title = "Form not found",
	description = "The form you're looking for doesn't exist or may have been deleted.",
}: FormNotFoundProps) {
	return (
		<div className="flex items-center justify-center min-h-screen bg-[#fafafa]">
			<div className="text-center max-w-md px-6">
				<div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="w-8 h-8 text-gray-400"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
						/>
					</svg>
				</div>
				<h2 className="text-xl font-semibold text-primary mb-2">{title}</h2>
				<p className="text-tertiary mb-6">{description}</p>
				<Button as={Link} to={`/${workspaceId}/forms`} variant="default">
					Back to Forms
				</Button>
			</div>
		</div>
	);
}
